






























import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "AtlassianLanding"
})
export default class AtlassianLanding extends Vue {}
